<script setup lang="ts">
import { computed, watchEffect } from "vue"

const props = defineProps<{
    password: string
}>()
const emit = defineEmits<{
    (e: "validate", valid: boolean): void
}>()

const hasUppercase = computed(() => /[A-Z]/.test(props.password))
const hasLowercase = computed(() => /[a-z]/.test(props.password))
const hasDigit = computed(() => /\d/.test(props.password))
const hasSpecialCharacter = computed(() => /[^a-zA-Z0-9]/.test(props.password))
const hasMinimumLength = computed(() => props.password.length >= 8)

watchEffect(() => {
    emit(
        "validate",
        hasUppercase.value &&
            hasLowercase.value &&
            hasDigit.value &&
            hasSpecialCharacter.value &&
            hasMinimumLength.value,
    )
})
</script>

<template>
    <div class="small">
        <div :class="hasUppercase ? 'text-success' : 'text-danger'">
            <i :class="hasUppercase ? 'fa-check-circle' : 'fa-times-circle'" class="fa fa-fw mr-1"></i>
            <span>Großbuchstabe enthalten</span>
        </div>
        <div :class="hasLowercase ? 'text-success' : 'text-danger'">
            <i :class="hasLowercase ? 'fa-check-circle' : 'fa-times-circle'" class="fa fa-fw mr-1"></i>
            <span>Kleinbuchstabe enthalten</span>
        </div>
        <div :class="hasDigit ? 'text-success' : 'text-danger'">
            <i :class="hasDigit ? 'fa-check-circle' : 'fa-times-circle'" class="fa fa-fw mr-1"></i>
            <span>Zahl enthalten</span>
        </div>
        <div :class="hasSpecialCharacter ? 'text-success' : 'text-danger'">
            <i :class="hasSpecialCharacter ? 'fa-check-circle' : 'fa-times-circle'" class="fa fa-fw mr-1"></i>
            <span>Sonderzeichen enthalten</span>
        </div>
        <div :class="hasMinimumLength ? 'text-success' : 'text-danger'">
            <i :class="hasMinimumLength ? 'fa-check-circle' : 'fa-times-circle'" class="fa fa-fw mr-1"></i>
            <span>Mindestens 8 Zeichen</span>
        </div>
    </div>
</template>
